import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Plan } from 'src/app/common/models/plan';
import { PlanService } from 'src/app/common/services/plan.service';

@Component({
    selector: 'app-year-end-reflections-wizard',
    templateUrl: './year-end-reflections-wizard.component.html',
    styleUrls: ['./year-end-reflections-wizard.component.css'],
    standalone: false
})
export class YearEndReflectionsWizardComponent implements OnInit {

  plan: Plan;
  isLoading = true;
  selectedIndex = 0;
  paramsSubscription: Subscription;

  constructor(private planService: PlanService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.paramsSubscription = this.route.params.subscribe(params => {
      this.planService.getPlan(params['id']).subscribe({
        next: (p) => {
          this.plan = p
          const yetab = localStorage.getItem("yetab-"+this.plan.PlanYear);
          this.selectedIndex = JSON.parse(yetab) ?? 0;
          this.isLoading = false;
        }
      })
    });
  }

  onTabChanged($event){
    localStorage.setItem("yetab-"+this.plan.PlanYear, $event.index);
  }
}
